"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
exports.IMAGE_RATIOS = {
    HORIZONTAL: 1.77,
    VERTICAL: 0.66,
};
//# sourceMappingURL=Images.js.map